import { render, staticRenderFns } from "./IrrigationPanelView.vue?vue&type=template&id=4beab586"
import script from "./IrrigationPanelView.vue?vue&type=script&lang=js"
export * from "./IrrigationPanelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports